import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import {
  Container, Spinner, Row, Col, Button,
  Modal, ModalHeader, ModalBody, ModalFooter,
  Card, CardBody,
  Label, FormGroup, Input,
} from 'reactstrap'
import moment from 'moment'
import MaskedInput from '../../../../components/Template/Input/MaskedInput'
import DatePicker from 'react-datepicker'
import Select from '../../../../components/Template/Input/Select'
import currencyFormatter from '../../../../utils/currencyFormatter'
import { getAtivTp, getAtivProducts } from '../../../../store/ducks/technicalDep'
import { notifySuccess, notifyError } from '../../../../utils/notify'
import oikosApi from '../../../../services/oikos'
import qs from 'qs'
import { selectValues, getRegs, insert, update, insOrUp, getDocs } from '../../../../utils/fc'

class Activities extends Component {
  constructor(props) {
    super(props)
    this.state = {
      addActivityModalIsOpen: false,
      addActivityData: {},
      activities: false,
      selSetorAtiv: false,
    }
  }

  componentDidMount() {
    this.preloading()
  }

  preloading = async () => {
    const { product, getAtivTp } = this.props
    this.setState({ selSetorAtiv: await selectValues('setorAtiv', 'setorAtiv_id', 'setorAtiv_nome', { setor_id: 9 }) })
    console.log('tipos de atividades = ', this.state.selSetorAtiv)

    if (product) {
      getAtivTp()
      this.getActivities(product.prod_id)
      console.log('product = ', product)
      console.log('prod_id  = ', product.prod_id)
    }
  }


  getActivities = async (prodId) => {
    const res = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'prodAtiv',
      data: {
        prod_id: prodId,
        prodAtiv_ativo: 1,
      },
      fields: {
        '(SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = prodAtiv.pf_id)': 'prodAtiv_responsavel_email',
        '(SELECT prodAtivStatusTp_nome FROM prodAtivStatusTp WHERE prodAtivStatusTp.prodAtivStatusTp_id = prodAtiv.prodAtivStatusTp_id)': 'prodAtiv_Status',
      },
    })}`)
    this.setState({ activities: res.data })
  }

  handleSubmitActivity = async () => {
    const { addActivityData } = this.state
    if (!addActivityData.prodAtiv_id) {
      try {
        const insertActivity = {
          action: 'insert',
          table: 'prodAtiv',
          data: {
            prod_id: addActivityData.prod_id,
            setorAtiv_id: addActivityData?.setorAtiv_id || undefined,
            prodAtiv_nome: addActivityData?.prodAtiv_nome,
            prodAtiv_desc: addActivityData?.prodAtiv_desc,
            pf_id: addActivityData?.pf_id,
            prodAtiv_tempo: addActivityData?.prodAtiv_tempo,
            prodAtiv_vlr: Number(addActivityData?.prodAtiv_vlr),
            prodAtiv_dtIni: addActivityData.prodAtiv_dtIni ? moment(addActivityData.prodAtiv_dtIni).format('YYYY-MM-DD') : undefined,
            prodAtiv_dtFim: addActivityData.prodAtiv_dtFim ? moment(addActivityData.prodAtiv_dtFim).format('YYYY-MM-DD') : undefined,
            prodAtivStatusTp_id: addActivityData.prodAtivStatusTp_id,
          },
        }
        console.log('insertActivity ', insertActivity)
        const activityCreated = await oikosApi.post('/', insertActivity)
        notifySuccess('Atividade cadastrada com sucesso.')
        this.getActivities(addActivityData.prod_id)
      } catch (e) {
        notifyError('Erro ao cadastrar a atividade')
        console.log('Não foi possível cadastrar a atividade.', e)
      }
    } else {
      try {
        const updateActivity = {
          action: 'update',
          table: 'prodAtiv',
          data: {
            prod_id: addActivityData.prod_id,
            prodAtiv_id: addActivityData.prodAtiv_id,
            setorAtiv_id: addActivityData?.setorAtiv_id || undefined,
            prodAtiv_nome: addActivityData?.prodAtiv_nome,
            prodAtiv_desc: addActivityData?.prodAtiv_desc,
            pf_id: addActivityData?.pf_id,
            prodAtiv_tempo: addActivityData?.prodAtiv_tempo,
            prodAtiv_vlr: Number(addActivityData?.prodAtiv_vlr),
            prodAtiv_dtIni: addActivityData.prodAtiv_dtIni ? moment(addActivityData.prodAtiv_dtIni).format('YYYY-MM-DD') : undefined,
            prodAtiv_dtFim: addActivityData.prodAtiv_dtFim ? moment(addActivityData.prodAtiv_dtFim).format('YYYY-MM-DD') : undefined,
            prodAtivStatusTp_id: addActivityData.prodAtivStatusTp_id,

          },
        }
        console.log('updateActivity ', updateActivity)
        const activityUpdated = await oikosApi.post('/', updateActivity)
        notifySuccess('Atividade atualizado com sucesso.')
        this.getActivities(addActivityData.prod_id)
      } catch (e) {
        notifyError('Erro ao atualizar a atividade')
        console.log('Não foi possível cadastrar a atividade.', e)
      }
    }
    this.setState({ addActivityModalIsOpen: false })
  }

  handleDeleteActivity = async (prodAtivId) => {
    const { addActivityData } = this.state
    try {
      const deleteAtiv = {
        action: 'delete',
        table: 'prodAtiv',
        data: {
          prodAtiv_id: prodAtivId,
        },
      }
      console.log('deleteAtiv ', deleteAtiv)
      const ativDeleted = await oikosApi.post('/', deleteAtiv)
      notifySuccess('Atividade removida com sucesso.')
      this.getActivities(addActivityData.prod_id)
    } catch (e) {
      notifyError('Erro ao remover o atividade')
      console.log('Não foi possível remover atividade.', e)
    }
    this.setState({ addActivityModalIsOpen: false })
  }

  render() {
    //const { isManager } = this.props.auth.user
    //if (!isManager) return <Redirect to="/" />

    const {
      ativTp, getAtivTpIsLoading,
      projectTeam, getTeamIsLoading,
    } = this.props.technicalDep

    const { product } = this.props

    const {
      addActivityModalIsOpen, addActivityData, activities, selSetorAtiv,
    } = this.state

    if (!activities) {
      return (
        <div className="centered">
          <Spinner />
        </div>
      )
    }
    if (activities) {
      return (
        <><div className="align-items-center">
          <Container fluid>
          <Button
            size="sm"
            color="link"
            type="button"
            className="mb-1 ml-1 px-0 my-3 mx-3"
            onClick={() => this.setState({
              addActivityModalIsOpen: true,
              addActivityData: {
                prod_id: product.prod_id,
                prodAtivStatusTp_id: 1 },
            })}
          >
            Adicionar Atividades
          </Button>
          { activities.map(ativ => (
            <Row>
              <Col>
                <Card>
                  <CardBody>
                    <Row className="align-items-center">
                      <Col>
                        <Row>
                          <Col>
                            <span>
                              {ativ.prodAtiv_nome}
                            </span>
                          </Col>
                          <Col>
                            <span>
                              {ativ.prodAtiv_desc}
                            </span>
                          </Col>
                          <Col>
                           <span>
                            {ativ.prodAtiv_responsavel_email}
                             </span>
                             </Col>
                          <Col>
                            <span>
                            {moment(ativ.prodAtiv_dtIni).format('DD/MM/YYYY')}
                            </span>
                            </Col>
                          <Col>
                            <span>
                            {moment(ativ.prodAtiv_dtFim).format('DD/MM/YYYY')}
                            </span>
                          </Col>
                          <Col>
                            <span>
                            {currencyFormatter.format(ativ.prodAtiv_vlr)}
                            </span>
                          </Col>
                          <Col>
                            <span>
                              {ativ.prodAtiv_tempo}
                            </span>
                          </Col>
                          <Col>
                            <span>
                              {ativ.prodAtiv_Status}
                            </span>
                          </Col>
                          <Col>
                            <Button
                              title="Editar"
                              className="ml-2"
                              color="light"
                              size="sm"
                              onClick={() => {
                                this.setState({
                                addActivityData: ativ,
                                addActivityModalIsOpen: true,
                                })
                              }}
                            >
                              <i className="ri-pencil-fill" />
                            </Button>
                            <Button
                              title="Excluir"
                              className="ml-2"
                              color="light"
                              size="sm"
                              onClick={() => {
                                this.setState({
                                  addActivityData: {
                                    prod_id: ativ.prod_id,
                                  },
                                })
                                this.getActivities(addActivityData.prod_id)
                                this.handleDeleteActivity(ativ.prodAtiv_id)
                              }}
                            >
                              <i className="ri-delete-bin-6-line" />
                            </Button>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          ))}
          </Container>
        </div>
          <>
          <Modal
            centered={false}
            isOpen={addActivityModalIsOpen}
            toggle={() => this.setState({ addActivityData: {}, addActivityModalIsOpen: false })}
          >
            <ModalHeader
              toggle={() => this.setState({
                addActivityData: {},
                addActivityModalIsOpen: false,
              })}
            >
              Adicionar Atividades
            </ModalHeader>
            <ModalBody>
            <FormGroup>
              <Label>Tipo de atividade</Label>
              <Select
                isSearchable
                isClearable
                isLoading={getAtivTpIsLoading}
                onChange={e => this.setState({
                  addActivityData: {
                    ...addActivityData,
                    setorAtiv_id: e.value,
                    prodAtiv_nome: e.label,
                  },
                })}
                placeholder="Tipo de atividade"
                options={selSetorAtiv}
                value={addActivityData?.setorAtiv_id}
            />
            </FormGroup>
            <FormGroup>
              <Label>
                Descrição
              </Label>
              <Input
                value={addActivityData?.prodAtiv_desc}
                onChange={e => this.setState({
                  addActivityData: {
                    ...addActivityData,
                    prodAtiv_desc: e.target.value || null,
                  },
                })}
              />
            </FormGroup>
            <FormGroup>
              <Label>Responsável</Label>
              <Select
                isSearchable
                isClearable
                isLoading={getTeamIsLoading}
                onChange={e => this.setState({
                  addActivityData: {
                    ...addActivityData,
                    pf_id: e.id,
                  },
                })}
                placeholder="Responsável"
                options={projectTeam}
                getOptionValue={option => option.id}
                getOptionLabel={option => option.nome}
              />
            </FormGroup>
            <FormGroup>
              <Label>
                Inicio
              </Label>

              <DatePicker
                placeholderText="__/__/_____"
                locale="pt-BR"
                className="form-control"
                dateFormat="dd/MM/yyyy"
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                selected={addActivityData?.prodAtiv_dtIni ? moment(addActivityData.prodAtiv_dtIni).toDate() : null}
                onChange={date => this.setState({
                  addActivityData: {
                    ...addActivityData,
                    prodAtiv_dtIni: date,
                    prod_dtIni_Invalid: false,
                  },
                })}
              />
            </FormGroup>
            <FormGroup>
              <Label>
                Fim
              </Label>

              <DatePicker
                placeholderText="__/__/_____"
                locale="pt-BR"
                className="form-control"
                dateFormat="dd/MM/yyyy"
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                selected={addActivityData?.prodAtiv_dtFim ? moment(addActivityData.prodAtiv_dtFim).toDate() : null}
                onChange={date => this.setState({
                  addActivityData: {
                    ...addActivityData,
                    prodAtiv_dtFim: date,
                    prod_dtFim_Invalid: false,
                  },
                })}
              />
            </FormGroup>
            <FormGroup>
              <Label>
                Valor
              </Label>
              <MaskedInput
                unmask
                mask="R$ num"
                value={addActivityData?.prodAtiv_vlr}
                blocks={{
                  num: {
                    mask: Number,
                    scale: 2, // digits after point 0 for integers
                    signed: false, // disallow negative
                    thousandsSeparator: '.', // any single char
                    padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                    normalizeZeros: false, // appends or removes zeros at ends
                    radix: ',', // fractional delimiter
                    min: 0,
                    max: 1000000000,
                  },
                }}
                lazy={false}
                onAccept={value => this.setState({
                  addActivityData: {
                    ...addActivityData,
                    prodAtiv_vlr: value,
                  },
                })}
              />
            </FormGroup>
            <FormGroup>
                <Label>Tempo</Label>
                <Input
                  className="form-control"
                  type="text"
                  value={addActivityData?.prodAtiv_tempo}
                  maxLength={6}
                  onChange={e => this.setState({
                    addActivityData:  {
                      ...addActivityData,
                      prodAtiv_tempo: e.target.value,
                    },
                  })}
                />
              </FormGroup>

            <ModalBody />
            <ModalFooter>
              <Button
                type="button"
                onClick={() => this.setState({ addActivityData: {}, addActivityModalIsOpen: false })}
                color="light"
                className="waves-effect"
              >
                Cancelar
              </Button>
              <Button
                type="button"
                color="primary"
                className="waves-effect waves-light"
                onClick={() => this.handleSubmitActivity()}
              >
                Adicionar
              </Button>

            </ModalFooter>
            </ModalBody>
          </Modal>

        </></>
      )
    }
    return null
  }
}

const labelStyle = {
  fontSize: '0.75rem',
  color: '#adb5bd',
  lineHeight: '1.5',
  marginTop: 16,
}

const mapStateToProps = state => ({
  auth: state.auth,
  technicalDep: state.technicalDep,
})
const mapDispatchToProps = dispatch => bindActionCreators({
  getAtivTp,
  getAtivProducts,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(Activities)
